module.exports = __webpack_public_path__ + "img/cast.533629fc.png";